// Reusable modal for "pick a value + apply to N records" flows (transfer, update, add-to-campaign).
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  confirmLabel: string;
  confirmDisabled?: boolean;
  confirmDanger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  error?: string | null;
}

export function BulkModal({
  open, onClose, title, description, children, confirmLabel,
  confirmDisabled, confirmDanger, busy, onConfirm, error,
}: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="flex w-full max-w-md flex-col rounded-lg border bg-card shadow-xl">
        <header className="flex items-center justify-between border-b px-4 py-2">
          <div className="text-sm font-medium">{title}</div>
          <button onClick={onClose} aria-label="Close" className="rounded-md p-1 hover:bg-muted">
            <X className="h-4 w-4" />
          </button>
        </header>
        <div className="space-y-3 p-4">
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
          {children}
          {error && <p className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</p>}
        </div>
        <footer className="flex items-center justify-end gap-2 border-t bg-card px-4 py-3">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button
            onClick={onConfirm}
            disabled={confirmDisabled || busy}
            variant={confirmDanger ? "destructive" : "default"}
          >
            {busy ? "Working…" : confirmLabel}
          </Button>
        </footer>
      </div>
    </div>
  );
}
